import script from "./leftline3.vue?vue&type=script&setup=true&lang=js"
export * from "./leftline3.vue?vue&type=script&setup=true&lang=js"

import "./leftline3.vue?vue&type=style&index=0&id=2cd5b29c&scoped=true&lang=css"
script.__scopeId = "data-v-2cd5b29c"

export default script